const BASE_URL = {
  production: "https://api.mookie.app",
  staging: "https://api-test.mookie.app",
  dev: "https://api-test.mookie.app",
};
  
export const MIXPANEL_KEY = {
  dev: process.env.REACT_APP_MIXPANEL_KEY_DEV,
  staging: process.env.REACT_APP_MIXPANEL_KEY_STAGING,
  production: process.env.REACT_APP_MIXPANEL_KEY_PRODUCTION
};
  
export default BASE_URL;